<div class="flash-list" *ngIf="(mensagens$ | async) as mensagens">
  <div
    *ngFor="let msg of mensagens; trackBy: trackById"
    class="flash"
    [ngClass]="'flash--' + msg.tipo"
    role="status"
    [attr.aria-live]="msg.tipo === 'error' ? 'assertive' : 'polite'"
  >
    <span class="flash__texto">{{ msg.texto }}</span>
    <button
      mat-icon-button
      type="button"
      class="flash__fechar"
      (click)="fechar(msg.id)"
      aria-label="Fechar mensagem"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
